import { render, staticRenderFns } from "./AppTabSubscriptionUserPlan.vue?vue&type=template&id=2e3506bc&scoped=true"
import script from "./AppTabSubscriptionUserPlan.vue?vue&type=script&lang=js"
export * from "./AppTabSubscriptionUserPlan.vue?vue&type=script&lang=js"
import style0 from "./AppTabSubscriptionUserPlan.vue?vue&type=style&index=0&id=2e3506bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3506bc",
  null
  
)

export default component.exports